// src/pages/ServicePaused.jsx
//
// Pantalla que ve cualquier usuario que no sea admin mientras el servicio
// esta en pausa. Reemplaza al dashboard, a /app y a todo lo que tenga que
// ver con pagar o registrarse.
//
// No muestra ningun dato del servicio: ni partidos, ni senales, ni
// historial, ni saldo. Solo el aviso y la salida de sesion.

import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { getAuth } from 'firebase/auth';
import { PAUSE_COPY, isPausedFor } from '../config/servicePaused';
import { useAuth } from '../auth/AuthContext';

/**
 * Envuelve una ruta que queda cerrada durante la pausa: registro, canje de
 * beta, cualquier cosa que cree una cuenta o cobre.
 *
 * Se usa en rutas donde puede no haber sesión, así que espera a que el
 * contexto resuelva antes de decidir. Sin esa espera un admin recargando
 * la página vería el aviso por un instante antes de que llegue su rol.
 */
export function PausedGate({ children }) {
  const { loading, isAdmin } = useAuth();
  if (loading) return null;
  if (isPausedFor(isAdmin)) return <ServicePaused conSalir={false} />;
  return children;
}

export default function ServicePaused({ conSalir = true }) {
  const navigate = useNavigate();

  async function salir() {
    try {
      await signOut(getAuth());
    } catch {
      /* si falla el cierre de sesion igual lo mandamos al inicio */
    }
    navigate('/', { replace: true });
  }

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Edge Elite está en pausa</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section
        className="screen"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '32px 24px',
          gap: 0,
        }}
      >
        <img
          src="/logo.png"
          alt=""
          aria-hidden="true"
          style={{ width: 64, height: 64, objectFit: 'contain', opacity: 0.85 }}
        />

        <h1
          style={{
            margin: '24px 0 0',
            fontSize: 22,
            lineHeight: 1.3,
            fontWeight: 600,
            color: 'var(--text, #e9eef5)',
          }}
        >
          {PAUSE_COPY.titulo}
        </h1>

        <p
          style={{
            margin: '12px 0 0',
            maxWidth: 380,
            fontSize: 15,
            lineHeight: 1.6,
            color: 'var(--muted, #9aa7b8)',
          }}
        >
          {PAUSE_COPY.cuerpo}
        </p>

        {conSalir && (
          <button
            type="button"
            onClick={salir}
            style={{
              marginTop: 32,
              padding: '12px 24px',
              borderRadius: 12,
              border: '1px solid var(--border, #24303f)',
              background: 'transparent',
              color: 'var(--muted, #9aa7b8)',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Cerrar sesión
          </button>
        )}
      </section>
    </div>
  );
}
